<template>
  <div class="evaluation-badge" v-bind:class="classBindings" v-if="domain">
    {{ domain.name }} <strong>{{ domain.grade }}</strong>
  </div>
</template>

<script>
  export default {
    name: 'evaluation-badge',

    props: {
      domain: {
        type: Object,
        default: null,
      },
    },

    computed: {
      grade() {
        if (this.domain.grade === '상') {
          return 'high';
        }

        if (this.domain.grade === '중') {
          return 'middle';
        }

        return 'low';
      },

      classBindings() {
        return {
          'high-grade': this.grade === 'high',
          'middle-grade': this.grade === 'middle',
          'low-grade': this.grade === 'low',
        };
      },
    },
  };
</script>

<style lang="scss">
  .evaluation-badge {
    display: inline-block;
    padding: 3px 9px;
    font-size: 14px;
    line-height: 1.29;
    text-align: center;
    border-radius: 100px;
    margin-right: 6px;

    &.high-grade {
      border: solid 1px #fa8471;
      color: #fa8471;
    }

    &.middle-grade {
      border: solid 1px #00c896;
      color: #00c896;
    }

    &.low-grade {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/evaluations/components/EvaluationBadge.vue